<template>
   <section class="video-fullscreen">
    <div class="video grayscale" data-overlay-dark="1">
        <div class="desgradado"></div>
      <video playsinline autoplay loop muted aria-label="Background Video">
        <source :src="videoMp4" type="video/mp4">
        <source :src="videoWebm" type="video/webm">
        <!-- Fallback for unsupported formats -->
        Your browser does not support HTML5 video.
      </video>
    
    </div>
    <div class="v-middle">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-12 mt-60">
            <h4 class="hZUCZe">{{ $t('Our services are designed to meet your needs') }}</h4>
            <h1 class="mb-10 text-h2-sans">{{ $t('Solutions') }}<br/><span>{{ $t('Creative and Technological') }}</span></h1>
          </div>
        </div>
      </div>
    </div>
  </section>
  
  <section class="services py-26">
    <div class="container">
        <div class="text-center">
            <h4 class="hZUCZe">{{ $t('Trust, Innovation and Solutions within Your Reach') }}</h4>
            <h2 class="text-h2-sans text-center">{{ $t("Discover why JLHSOFT is Our Customers' Choice.") }}</h2>
        </div>
        <div class="row" style="margin: 0; padding: 0;">
            <div class="col-md-4 mt-10">
                <div class="sr-border">
                    <img :src="streamlined" alt="">
                    <h4 class="mt-3 mb-0 h5">{{ $t('Web Design and Development') }}</h4>
                    <p class="mt-6-until-sm mt-3 mb-0">{{ $t('We focus on attractive design, intuitive functionality and compatibility across devices.') }}</p>
                </div>
            </div>
            <div class="col-md-4 mt-10">
                <div class="sr-border">
                    <img :src="streamlined" alt="">
                    <h4 class="mt-3 mb-0 h5">{{ $t('Electronic Commerce') }}</h4>
                    <p class="mt-6-until-sm mt-3 mb-0">{{ $t('We design and develop functional, secure and attractive e-commerce platforms. From user experience to inventory management, we help you sell successfully online.') }}</p>
                </div>
            </div>
            <div class="col-md-4 mt-10">
                <div class="sr-border">
                    <img :src="streamlined" alt="">
                    <h4 class="mt-3 mb-0 h5">{{ $t('Mobile & Desktop App') }}</h4>
                    <p class="mt-6-until-sm mt-3 mb-0">{{ $t('We design and develop mobile and desktop applications that combine advanced functionality and intuitive design.') }}</p>
                </div>
            </div>
            <div class="col-md-4 mt-10">
                <div class="sr-border">
                    <img :src="performance" alt="">
                    <h4 class="mt-3 mb-0 h5">{{ $t('Graphic Design and Animation') }}</h4>
                    <p class="mt-6-until-sm mt-3 mb-0">{{ $t("Our animations and designs help capture your audience's attention and communicate your message creatively and effectively.") }}</p>
                </div>
            </div>
            <div class="col-md-4 mt-10">
                <div class="sr-border">
                    <img :src="publics" alt="">
                    <h4 class="mt-3 mb-0 h5">{{ $t('Digital Marketing') }}</h4>
                    <p class="mt-6-until-sm mt-3 mb-0">{{ $t('We are dedicated to understanding and meeting the unique needs of each client, offering customized solutions that generate tangible results.') }}</p>
                </div>
            </div>
            
            <div class="col-md-4 mt-10">
                <div class="sr-border">
                    <img :src="community" alt="">
                    <h4 class="mt-3 mb-0 h5">{{ $t('Social Networks') }}</h4>
                    <p class="mt-6-until-sm mt-3 mb-0">{{ $t('We manage your social networks to build an active and committed community. We create relevant content, manage publications and analyze results to improve the connection with your audience.') }}</p>
                </div>
            </div>
            
        </div>
        <div class="text-center py-26">
            <ButtonContact />
        </div>
    </div>
</section>
</template>

<script>
import videoMp4 from '@/assets/videos/video_service.mp4'
import streamlined from '@/assets/svgs/streamlined.svg'
import performance from '@/assets/svgs/performance.svg'
import publics from '@/assets/svgs/public.svg'
import community from '@/assets/svgs/community.svg'
import ButtonContact from '@/components/ButtonContact.vue'

export default {
    name: 'ServicesPage',
    components: {
        ButtonContact
    },
    data() {
        return {
          videoMp4,
          streamlined,
          performance,
          publics,
          community
         
        };
    },
}
</script>

<style scoped>
.video-fullscreen {
    overflow: hidden;
  }
  .video-fullscreen .video.grayscale {
      -webkit-filter: grayscale(100%);
      filter: grayscale(100%);
  }
  .video-fullscreen .video {
      height: 100vh;
  }
  .video-fullscreen video {
    width: 100vw;
    min-width: 100%;
    height: 100vh;
    object-position: top;
    -o-object-fit: cover;
    object-fit: cover;
  }

  .v-middle {
    position: absolute;
    width: 100%;
    top: 50%;
    left: 0;
    -webkit-transform: translate(0%, -50%);
    transform: translate(0%, -50%);
    z-index: 9;
}

.services{
    width: 100%;
    text-align: left;
}

.services h3{
    text-align: center;
}

.services h4{
    color: #fff;
    font-size: 20px;
}

.services p{
    color: #fff;
    font-size: 16px;
    font-weight: 300 !important;
}

.despc{
    color: #f1f1f1;
}

</style>